import moment from 'moment';
import { isEqual, get } from 'lodash-es';
import Stopwatch from '@/launcher/services/stopwatch';
import * as workerTimers from 'worker-timers';
import { sendImpulse } from '@/launcher/actions/impulse';
import * as Sentry from '@sentry/browser';
import store from '@/core/store';
import { generateUUID } from '../../core/shared/helpers/VariousHelper';
import {
  revisionHelpers,
} from '@/launcher/helpers/version';

let stopwatch;
let currentToken;
function recordImpulse (data, duration) {
  if (duration > 0) {
    try {
      const station = store.getters.currentStation;
      const organization = station.organization;
      const location = station.location;
      const impulse = {
        client_recorded_at: moment().toISOString(), // required
        state: data.idle ? 'idle' : 'play', // 'idle' | 'play' | 'overlay', // required
        duration, // required
        organization: { // required
          uuid: organization.id, // required
          title: organization.name, // required
          country: organization.country, // required
          region: organization.state || undefined, // required
        },
        location: { // required
          uuid: location.id, // required
          title: location.title, // required
          country: location.country,
          region: location.state || undefined,
        },
        station: { // required
          uuid: station.id, // required
          title: station.title, // required
        },
        content: data.game ? {
          uuid: data.game.id || undefined, // required
          type: data.type, // required
          title: data.game.title, // required
          preset: data.preset ? {
            uuid: data.preset.id, // required
            title: data.preset.title, // required
          } : undefined,
          license: data.license ? {
            uuid: data.license.id, // required
          } : undefined,
          ownership: data.ownership ? {
            uuid: data.ownership.id, // required
          } : undefined,
        } : undefined,
        booking: data.booking.id ? {
          uuid: data.booking.id, // required
        } : undefined,
        customer: data.customer.id ? {
          uuid: data.customer.id, // required
        } : undefined,
      };
      sendImpulse(impulse);
    } catch (e) {
      Sentry.addBreadcrumb({
        category: 'impulse',
        message: 'impulse data',
        data: data,
      });
      Sentry.captureException(e);
    }
  }
}
function setupImpulseWatcher () {
  store.watch((state, getters) => {
    get(getters, 'safetyMode'); // track safety mode
    return getters.sessionDataForImpulse;
  }, (currentAppState, previousAppState) => {
    if (!currentAppState) return;
    if (!isEqual(currentAppState, previousAppState)) {
      createImpulse({
        currentAppState,
        previousAppState,
      });
    }
  }, { immediate: true });
}

function createImpulse ({ currentAppState, previousAppState }, token = generateUUID()) {
  currentToken = token;
  const duration = stopwatch && Math.round(stopwatch.stop());
  if (previousAppState && duration) recordImpulse(previousAppState, duration);
  stopwatch = new Stopwatch();
  workerTimers.setTimeout(() => {
    if (token === currentToken) {
      createImpulse({ currentAppState, previousAppState: currentAppState }, token);
    }
  }, 60000);
}

export default {
  async created () {
    await new Promise((resolve) => {
      if (store.state.launcher.desktopClientVersion) resolve();
      const unsub = store.watch((state, getters) => state.launcher.desktopClientVersion,
        (version) => {
          if (version) {
            unsub();
            resolve();
          }
        });
    });
    revisionHelpers.introduceInVersion('4.3.34', () => {
      setupImpulseWatcher();
    });
  },
};
